import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _42b5aa8f = () => interopDefault(import('../modules/checkout/pages/Cart.vue' /* webpackChunkName: "" */))
const _64f0b635 = () => interopDefault(import('../modules/checkout/pages/Checkout.vue' /* webpackChunkName: "" */))
const _78953a81 = () => interopDefault(import('../modules/checkout/pages/Checkout/Billing.vue' /* webpackChunkName: "" */))
const _17448c8c = () => interopDefault(import('../modules/checkout/pages/Checkout/Payment.vue' /* webpackChunkName: "" */))
const _4c6767d0 = () => interopDefault(import('../modules/checkout/pages/Checkout/Shipping.vue' /* webpackChunkName: "" */))
const _794bd082 = () => interopDefault(import('../modules/checkout/pages/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _dd5b5d30 = () => interopDefault(import('../modules/checkout/pages/Checkout/UserAccount.vue' /* webpackChunkName: "" */))
const _c9ea8bbe = () => interopDefault(import('../pages/Cms.vue' /* webpackChunkName: "pages/Cms" */))
const _939fede8 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _5d3fcc7a = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _2f5d3eaa = () => interopDefault(import('../modules/customer/pages/MyAccount/MyNewsletter.vue' /* webpackChunkName: "" */))
const _77e71676 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _56ac680c = () => interopDefault(import('../modules/customer/pages/MyAccount/MyReviews.vue' /* webpackChunkName: "" */))
const _8076a814 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyWishlist.vue' /* webpackChunkName: "" */))
const _a039468c = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _dd9d1674 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressNew.vue' /* webpackChunkName: "" */))
const _fcff2596 = () => interopDefault(import('../modules/customer/pages/MyAccount/ResetPassword.vue' /* webpackChunkName: "" */))
const _b5fb9658 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressEdit.vue' /* webpackChunkName: "" */))
const _2d52bdf9 = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/SingleOrder/SingleOrder.vue' /* webpackChunkName: "" */))
const _30282537 = () => interopDefault(import('../pages/Home.vue' /* webpackChunkName: "" */))
const _2527156e = () => interopDefault(import('../pages/Faq.vue' /* webpackChunkName: "pages/Faq" */))
const _ff458a32 = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cart",
    component: _42b5aa8f,
    name: "cart___default___default"
  }, {
    path: "/checkout",
    component: _64f0b635,
    name: "checkout___default___default",
    children: [{
      path: "billing",
      component: _78953a81,
      name: "billing___default___default"
    }, {
      path: "payment",
      component: _17448c8c,
      name: "payment___default___default"
    }, {
      path: "shipping",
      component: _4c6767d0,
      name: "shipping___default___default"
    }, {
      path: "thank-you",
      component: _794bd082,
      name: "thank-you___default___default"
    }, {
      path: "user-account",
      component: _dd5b5d30,
      name: "user-account___default___default"
    }]
  }, {
    path: "/Cms",
    component: _c9ea8bbe,
    name: "Cms___default___default"
  }, {
    path: "/customer",
    component: _939fede8,
    meta: {"titleLabel":"My Account"},
    name: "customer___default___default",
    children: [{
      path: "addresses-details",
      component: _5d3fcc7a,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___default___default"
    }, {
      path: "my-newsletter",
      component: _2f5d3eaa,
      meta: {"titleLabel":"My newsletter"},
      name: "customer-my-newsletter___default___default"
    }, {
      path: "my-profile",
      component: _77e71676,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___default___default"
    }, {
      path: "my-reviews",
      component: _56ac680c,
      meta: {"titleLabel":"My reviews"},
      name: "customer-my-reviews___default___default"
    }, {
      path: "my-wishlist",
      component: _8076a814,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___default___default"
    }, {
      path: "order-history",
      component: _a039468c,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___default___default"
    }, {
      path: "addresses-details/create",
      component: _dd9d1674,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___default___default"
    }, {
      path: "/default/reset-password",
      component: _fcff2596,
      alias: "/customer/account/createPassword",
      name: "reset-password___default___default"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _b5fb9658,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___default___default"
    }, {
      path: "order-history/:orderId",
      component: _2d52bdf9,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___default___default"
    }]
  }, {
    path: "/default",
    component: _30282537,
    name: "home___default"
  }, {
    path: "/Faq",
    component: _2527156e,
    name: "Faq___default___default"
  }, {
    path: "/Home",
    component: _30282537,
    name: "Home___default___default"
  }, {
    path: "/Page",
    component: _ff458a32,
    name: "Page___default___default"
  }, {
    path: "/default/cart",
    component: _42b5aa8f,
    name: "cart___default"
  }, {
    path: "/default/checkout",
    component: _64f0b635,
    name: "checkout___default",
    children: [{
      path: "billing",
      component: _78953a81,
      name: "billing___default"
    }, {
      path: "payment",
      component: _17448c8c,
      name: "payment___default"
    }, {
      path: "shipping",
      component: _4c6767d0,
      name: "shipping___default"
    }, {
      path: "thank-you",
      component: _794bd082,
      name: "thank-you___default"
    }, {
      path: "user-account",
      component: _dd5b5d30,
      name: "user-account___default"
    }]
  }, {
    path: "/default/Cms",
    component: _c9ea8bbe,
    name: "Cms___default"
  }, {
    path: "/default/customer",
    component: _939fede8,
    meta: {"titleLabel":"My Account"},
    name: "customer___default",
    children: [{
      path: "addresses-details",
      component: _5d3fcc7a,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___default"
    }, {
      path: "my-newsletter",
      component: _2f5d3eaa,
      meta: {"titleLabel":"My newsletter"},
      name: "customer-my-newsletter___default"
    }, {
      path: "my-profile",
      component: _77e71676,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___default"
    }, {
      path: "my-reviews",
      component: _56ac680c,
      meta: {"titleLabel":"My reviews"},
      name: "customer-my-reviews___default"
    }, {
      path: "my-wishlist",
      component: _8076a814,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___default"
    }, {
      path: "order-history",
      component: _a039468c,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___default"
    }, {
      path: "addresses-details/create",
      component: _dd9d1674,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___default"
    }, {
      path: "/default/reset-password",
      component: _fcff2596,
      alias: "/customer/account/createPassword",
      name: "reset-password___default"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _b5fb9658,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___default"
    }, {
      path: "order-history/:orderId",
      component: _2d52bdf9,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___default"
    }]
  }, {
    path: "/default/Faq",
    component: _2527156e,
    name: "Faq___default"
  }, {
    path: "/default/Home",
    component: _30282537,
    name: "Home___default"
  }, {
    path: "/default/Page",
    component: _ff458a32,
    name: "Page___default"
  }, {
    path: "/default/:slug+",
    component: _ff458a32,
    name: "page___default"
  }, {
    path: "/",
    component: _30282537,
    name: "home___default___default"
  }, {
    path: "/:slug+",
    component: _ff458a32,
    name: "page___default___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
